import { RolesRouteConfig } from '@emfood/shared/src/providers/auth/guard/index-route-guard';

// TODO: Move to shared
export const PERMISSIONS = {
  USERS_READ: 'users:read',
  USERS_WRITE: 'users:write',
  USERS_INVITE: 'users:invite',
  USERS_REACTIVATE: 'users:reactivate',
  USERS_CREATE_ORDER_ISSUE_REPLY: 'users:create-order-issue-reply',
  // Products
  PRODUCTS_READ: 'products:read',
  PRODUCTS_WRITE: 'products:write',
  PRODUCT_PRICES_READ: 'product-prices:read',
  PRODUCT_PRICES_WRITE: 'product-prices:write',
  PRODUCT_STOCKS_READ: 'product-stocks:read',
  PRODUCT_STOCKS_WRITE: 'product-stocks:write',
  PRODUCTS_EXPORT: 'products:export',
  // General
  GENERAL: 'general',
  // Files
  FILES_WRITE: 'files:write',
  // Buyer Orgs
  BUYER_ORGS_READ: 'buyer-orgs:read',
  BUYER_ORGS_WRITE: 'buyer-orgs:write',
  // Buyer Sites
  BUYER_SITES_READ: 'buyer-sites:read',
  BUYER_SITES_WRITE: 'buyer-sites:write',
  BUYER_SITES_READ_SEASONS: 'buyer-sites:read-seasons',
  BUYER_SITES_READ_LINKED_SITES: 'buyer-sites:read-linked-sites',
  BUYER_SITES_READ_PRODUCERS: 'buyer-sites:read-producers',
  // Producers
  PRODUCERS_READ: 'producers:read',
  PRODUCERS_WRITE: 'producers:write',
  PRODUCERS_READ_MEASUREMENTS: 'producers:read-measurements',
  PRODUCERS_WRITE_MEASUREMENTS: 'producers:write-measurements',
  // Distributors
  DISTRIBUTORS_LIST_ADMIN: 'distributors:list-admin',
  DISTRIBUTORS_CREATE: 'distributors:create',
  DISTRIBUTORS_READ: 'distributors:read',
  DISTRIBUTORS_WRITE: 'distributors:write',
  DISTRIBUTOR_SITES_READ: 'distributor-sites:read',
  DISTRIBUTOR_SITES_WRITE: 'distributor-sites:write',
  DISTRIBUTORS_READ_BUYER_ORDERS: 'distributors:read-buyer-orders',
  DISTRIBUTOR_SITES_WRITE_CATALOGUE: 'distributor-sites:write-catalogue',
  DISTRIBUTORS_CREATE_PRODUCT: 'distributors:create-product',
  DISTRIBUTORS_BULK_IMPORT_PRODUCTS: 'distributors:bulk-import-products',
  // Prices
  DISTRIBUTORS_BULK_IMPORT_PRODUCT_PRICES: 'distributors:bulk-import-product-prices',
  DISTRIBUTORS_BULK_IMPORT_CUSTOM_PRODUCT_PRICES: 'distributors:bulk-import-custom-product-prices',
  PRICES_EXPORT: 'prices:export',
  PRICES_EXPORT_CUSTOM: 'prices:export-custom',
  //
  DISTRIBUTOR_SITES_READ_BUYER_ORDERS: 'distributor-sites:read-buyer-orders',
  ORDERS_EXPORT_PO: 'orders:export-po',
  ORDERS_EXPORT_GRN: 'orders:export-grn',
  ORDERS_EXPORT_CNR: 'orders:export-cnr',
  DISTRIBUTORS_READ_LINKED_SITES: 'distributors:read-linked-sites',
  DISTRIBUTORS_READ_ORDER_ISSUES: 'distributors:read-order-issues',
  DISTRIBUTORS_REPLY_ORDER_ISSUES: 'distributors:reply-order-issues',
  // Distributor site linking
  DISTRIBUTOR_SITE_LINK_TO_BUYER: 'distributor-site:link-to-buyer',
  // Distributor seasons
  DISTRIBUTORS_READ_SEASONS: 'distributors:read-seasons',
  DISTRIBUTORS_READ_SEASONS_ADMIN: 'distributors:read-seasons-admin',
  DISTRIBUTORS_WRITE_SEASONS: 'distributors:write-seasons',
  // Orders
  ORDERS_READ_ALL: 'orders:read-all',
  ORDERS_READ: 'orders:read',
  ORDERS_WRITE_ISSUES: 'orders:write-issues',
  ORDERS_READ_ISSUES: 'orders:read-issues',
  ORDERS_EXPORT_USER_PO: 'orders:export-user-po',
  ORDERS_EXPORT_USER_GRN: 'orders:export-user-grn',
  ORDERS_EXPORT_USER_CNR: 'orders:export-user-cnr',
  ORDERS_ADD_WEIGHT_RECEIVED: 'orders:add-weight-recieved',
  // Measuring methods
  MEASURING_METHODS_READ: 'measuring-methods:read',
  MEASURING_METHODS_WRITE: 'measuring-methods:write',
  MEASURING_METHOD_REQUESTS_WRITE: 'measuring-method-requests:write',
  MEASURING_METHOD_REQUESTS_READ: 'measuring-method-requests:read',
  // Measurements
  MEASUREMENTS_READ: 'measurements:read',
  MEASUREMENTS_DELETE: 'measurements:delete',
  MEASUREMENTS_RESOLVE: 'measurements:resolve',
  // Markers
  MARKERS_READ: 'markers:read',
  MARKERS_WRITE: 'markers:write',
  MARKER_INSTANCE_WRITE: 'marker-instance:write',
  // News
  NEWS_READ: 'news:read',
  NEWS_WRITE: 'news:write',
  // Cart
  CART: 'cart',
  // Favourites
  FAVOURITES_READ: 'favourites:read',
  FAVOURITES_WRITE: 'favourites:write',
  FAVOURITES_SHARE: 'favourites:share',
  // Shoppers
  BROWSE_PRODUCTS: 'browse-products',
  // Stories
  STORIES_GENERATE: 'stories:generate',
  STORIES_READ: 'stories:read',
  // Finance
  FINANCE_READ: 'finance:read',
};

export const ROLES = {
  ADMIN: 'Full Access Admin',
  ENTEGRA_USER: 'Entegra User',
  DISTRIBUTOR_ADMIN: 'Distributor Admin',
  PRODUCER_ADMIN: 'Producer Admin',
  BUYER: 'Chef',
  CHARITY_BUYER: 'Charity Buyer',
  CATERING_MANAGER: 'Catering Manager',
  BUYER_ADMIN: 'Buyer Admin',
} as const;

export const ROLE_RESTRICTIONS: Record<
  string,
  { isOrgRestricted: boolean; isSiteRestricted: boolean }
> = {
  [ROLES.ADMIN]: { isOrgRestricted: false, isSiteRestricted: false },
  [ROLES.ENTEGRA_USER]: { isOrgRestricted: false, isSiteRestricted: false },
  [ROLES.DISTRIBUTOR_ADMIN]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.PRODUCER_ADMIN]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.BUYER]: { isOrgRestricted: true, isSiteRestricted: true },
  [ROLES.CHARITY_BUYER]: { isOrgRestricted: true, isSiteRestricted: true },
  [ROLES.BUYER_ADMIN]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.CATERING_MANAGER]: { isOrgRestricted: true, isSiteRestricted: false },
} as const;

export const ALLOWED_ROLES = ['Chef', 'Catering Manager', 'Buyer Admin'] as const;

export const rolesIndexRouteConfig: RolesRouteConfig = {
  roleResolvers: [
    // Higher priority roles first
    {
      roleName: ROLES.BUYER,
      resolver: () => ({
        path: '/products',
      }),
    },
    {
      roleName: ROLES.CATERING_MANAGER,
      resolver: () => ({
        path: '/products',
      }),
    },
    {
      roleName: ROLES.CHARITY_BUYER,
      resolver: () => ({
        path: '/products',
      }),
    },
    {
      roleName: ROLES.BUYER_ADMIN,
      resolver: () => ({
        path: '/finance',
      }),
    },
  ],
  fallbackRoute: '/user',
};
